import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAFPbfGF9li-bkQHjgRsJtgkO4AhXdkh3w",
  authDomain: "erwinvanbrussel-58edc.firebaseapp.com",
  projectId: "erwinvanbrussel-58edc",
  storageBucket: "erwinvanbrussel-58edc.firebasestorage.app",
  messagingSenderId: "372229480638",
  appId: "1:372229480638:web:7c7744d06cff85a923beef"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
